import React from 'react';
import { Link } from 'react-router-dom';

interface SocialLink {
  name: string;
  url: string;
  icon: React.ReactNode;
}

const Footer: React.FC = () => {
  const socialLinks: SocialLink[] = [
    {
      name: 'Twitter/X',
      url: 'https://x.com/jmcichon',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.714-7.548L2.908 21.75H.564l7.73-8.835L.564 2.25h3.308l5.142 6.75 6.75-6.75zm-1.074 16.74h2.072L7.084 4.126H4.992l12.178 14.864z" />
        </svg>
      ),
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/joseph-cichon-md-phd-7557b43a0/',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      ),
    },
    {
      name: 'Google Scholar',
      url: 'https://scholar.google.com/citations?user=enV6dKEAAAAJ&hl=en',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M5.242 13.769L0 9.5 12 0l12 9.5-5.242 4.269C17.548 11.249 14.978 9.5 12 9.5c-2.977 0-5.548 1.748-6.758 4.269zM12 10.5c3.026 0 5.973 1.5 8.242 4.269L24 18.5 12 28 0 18.5l3.758-3.731C6.027 12 8.974 10.5 12 10.5z" />
        </svg>
      ),
    },
  ];

  return (
    <footer className="bg-penn-blue text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">Cichon Lab</h3>
            <p className="text-white/80 leading-relaxed mb-4">
              Advancing our understanding of neural circuits underlying consciousness,
              mood, and pain through innovative neuroscience research.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white transition-colors"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors">
                  Research
                </Link>
              </li>
              <li>
                <Link to="/team" className="text-white/80 hover:text-white transition-colors">
                  Team
                </Link>
              </li>
              <li>
                <Link to="/publications" className="text-white/80 hover:text-white transition-colors">
                  Publications
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <p className="text-white/80 mb-2">
              3620 Hamilton Walk
              <br />
              27 John Morgan
              <br />
              Philadelphia, PA 19104
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">I find these interesting...</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://www3.pennmedicine.org/departments-and-centers/anesthesiology-and-critical-care/research/labs-and-centers/center-for-the-neuroscience-of-unconsciousness-and-reanimation-research-alliance" className="text-white/80 hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer">
                  Center for the Neuroscience of Unconsciousness and Reanimation Research Alliance (NEURRAL)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center text-white/60">
          <p>&copy; {new Date().getFullYear()} Cichon Lab. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


